import React from 'react';
import '../styles/StorefrontAppointmentCancel.css';

const CANCEL_REASONS = [
  'Can no longer make the time',
  'The price is too high',
  'I found a better option elsewhere',
  'Other',
];

const StorefrontCancelAppointmentDialog = ({
  open,
  isProcessing,
  selectedReason,
  otherReason,
  cancelReasonError,
  onSelectReason,
  onOtherReasonChange,
  onClose,
  onConfirm,
}) => {
  if (!open) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !isProcessing) {
      onClose();
    }
  };

  return (
    <div
      className="sf-cancel-modal-overlay"
      role="presentation"
      onClick={handleOverlayClick}
    >
      <div
        className="sf-cancel-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="sf-cancel-dialog-title"
        aria-describedby="sf-cancel-dialog-description"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sf-cancel-modal__header">
          <h2 className="sf-cancel-modal__title" id="sf-cancel-dialog-title">
            Cancel appointment
          </h2>
          <button
            type="button"
            className="sf-cancel-modal__close"
            onClick={onClose}
            disabled={isProcessing}
            aria-label="Close"
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
              <path
                d="M1 1l12 12M13 1L1 13"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>

        <p className="sf-cancel-modal__intro" id="sf-cancel-dialog-description">
          Are you sure you want to cancel this appointment? This cannot be undone.
        </p>

        <fieldset className="sf-cancel-modal__reasons">
          <legend className="sf-cancel-modal__legend">Reason for cancellation</legend>
          {CANCEL_REASONS.map((reason) => (
            <label
              key={reason}
              className={`sf-cancel-modal__reason${selectedReason === reason ? ' is-selected' : ''}`}
            >
              <input
                type="radio"
                name="cancel-reason"
                value={reason}
                checked={selectedReason === reason}
                disabled={isProcessing}
                onChange={() => onSelectReason(reason)}
              />
              <span className="sf-cancel-modal__reason-label">{reason}</span>
            </label>
          ))}
        </fieldset>

        {selectedReason === 'Other' ? (
          <textarea
            className="sf-cancel-modal__other"
            placeholder="Please tell us why you are cancelling…"
            value={otherReason}
            disabled={isProcessing}
            onChange={(e) => onOtherReasonChange(e.target.value)}
            aria-label="Cancellation details"
          />
        ) : null}

        {cancelReasonError ? (
          <p className="sf-cancel-modal__error" role="alert">
            {cancelReasonError}
          </p>
        ) : null}

        <div className="sf-cancel-modal__actions">
          <button
            type="button"
            className="sf-cancel-btn sf-cancel-btn--secondary"
            onClick={onClose}
            disabled={isProcessing}
          >
            Keep appointment
          </button>
          <button
            type="button"
            className={`sf-cancel-btn sf-cancel-btn--danger${isProcessing ? ' is-loading' : ''}`}
            onClick={onConfirm}
            disabled={isProcessing}
          >
            {isProcessing ? 'Cancelling…' : 'Yes, cancel'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StorefrontCancelAppointmentDialog;
export { CANCEL_REASONS };
